// Package Block
import { Row, Col, Spin } from "antd";
import { shallowEqual, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

// Custom Components & Functions Block
import { TilesWidget } from "../../common";
import { formatAndShortNumber, formatCurrency, getSettingKey } from "../../../../../Common/utils";
import { hasRestrictivePermission, Permission } from "../../../../../Common/constants";
import { useDashboardBalanceVisibility } from "../../balanceVisibility";


const data = {
  total_products: {
    icon: "/media/svg/icons/Shopping/boxes.svg",
    title: <FormattedMessage id="Total Products" defaultMessage="Total Products" />,
    iconColor: "primary",
    url: "/catalog/products",
  },
  total_stock_price: {
    icon: "/media/svg/icons/Shopping/cash.svg",
    title: <FormattedMessage id="Total Extended Stock" defaultMessage="Total Extended Stock" />,
    iconColor: "success",
    tooltipContent:
      "The total amount of inventory that is available in your channels. The total qty of products that you hold multiplied by their respective prices. Archived and damaged stock are not included in this calculation.",
    url: "/reporting/inventory-report/inventory-valuation-report",
  },
  total_categories: {
    icon: "/media/svg/icons/Shopping/diagram-3.svg",
    title: <FormattedMessage id="Total Categories" defaultMessage="Total Categories" />,
    iconColor: "primary",
    url: "/catalog/categories",
  },
  total_brands: {
    icon: "/media/svg/icons/Shopping/tag.svg",
    title: <FormattedMessage id="Total Brands" defaultMessage="Total Brands" />,
    iconColor: "info",
    url: "/catalog/brands",
  },
  total_customers: {
    icon: "/media/svg/icons/General/User.svg",
    title: <FormattedMessage id="Total Customers" defaultMessage="Total Customers" />,
    iconColor: "warning",
    url: "/sale/customers",
  },
  total_suppliers: {
    icon: "/media/svg/icons/Shopping/people.svg",
    title: <FormattedMessage id="Total Suppliers" defaultMessage="Total Suppliers" />,
    iconColor: "danger",
    url: "/inventory/suppliers",
  },
};

export default function ({ loading, stats }) {

  const { currentState } = useSelector((state) => ({ currentState: state.basicSettings }), shallowEqual);
  const currencySymbol = getSettingKey(currentState.entity, "Basic", "currency_symbol");
  const hideCostPrices = hasRestrictivePermission(Permission.HideCostPrices);
  const { formatCurrencyValue } = useDashboardBalanceVisibility();

  const serverData = {
    // According to the current requirements we don't need to formatize the current in Million or Trillion so that's why I am commenting this code
    // Note: In future if we need to formatiz as like 12M or 14T so just uncomment below line it will work fine
    // total_stock_price: currencySymbol + formatAndShortCurrency(stats?.total_stock_cost).toUpperCase(),
    total_stock_price: hideCostPrices ? (
      <span style={{ filter: "blur(4px)", userSelect: "none" }}>000.00</span>
    ) : (
      formatCurrencyValue(stats?.total_stock_cost, currencySymbol, (amount) => formatCurrency(amount).toLocaleString())
    ),
    total_products: formatCurrency(stats?.total_products).toLocaleString(),
    total_categories: formatAndShortNumber(stats?.total_categories),
    total_brands: formatAndShortNumber(stats?.total_brands),
    total_customers: formatCurrency(stats?.total_customers).toLocaleString(),
    total_suppliers: formatAndShortNumber(stats?.total_suppliers),
  };
  
  return (
    <Spin spinning={loading}>
      <Row gutter={[10, 10]}>
        {Object.keys(serverData).map((key) => (
          <Col span={12} lg={8} key={key}>
            <TilesWidget data={data[key]} value={serverData[key]} />
          </Col>
        ))}
      </Row>
    </Spin>
  );
}
